import React from "react";
import { Desktop, Tablet, Mobile } from "../../utils/BannerUtil";
import { FormattedMessage } from "react-intl";
import FeatureUtil from "../../utils/FeatureUtil";
import { Banner } from "../../stores/BannerStore";

type Props = {
    isI18n: boolean;
    className: string;
    textAlignment: string;
    imageDesktop: string;
    imageTablet?: string | null | undefined;
    imageMobile?: string | null | undefined;
    bannerText?: string;
};

export class Teaser extends React.Component<Props> {
    renderTeaserContent(bannerText: string) {
        return (
            <div className="mfcss_teaser-big-overlay">
                <div className="mfcss_teaser-big-container">
                    <div className="mfcss_teaser-big-headline">
                        {this.props.isI18n ? (
                            <h1>
                                <FormattedMessage id={bannerText} />
                            </h1>
                        ) : (
                            <h1>{bannerText}</h1>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    renderBackgoundImage(bannerImage: string) {
        const className = this.props.className + " mfcss_teaser-big-" + this.props.textAlignment;
        const blockGifs = FeatureUtil.shouldUseBlockGifs();
        let image = bannerImage;
        if (blockGifs) {
            image = bannerImage + "?format=jpg&quality=80&dpi=72";
        }
        return (
            <div className={className} style={{ backgroundImage: 'url("' + image + '")' }}>
                {this.props.bannerText && this.renderTeaserContent(this.props.bannerText)}
            </div>
        );
    }

    render() {
        const imageDesktop = this.props.imageDesktop;
        const imageTablet = this.props.imageTablet ? this.props.imageTablet : imageDesktop;
        const imageMobile = this.props.imageMobile ? this.props.imageMobile : imageTablet;
        return (
            <div>
                <Desktop>{this.renderBackgoundImage(imageDesktop)}</Desktop>
                <Tablet>{this.renderBackgoundImage(imageTablet)}</Tablet>
                <Mobile>{this.renderBackgoundImage(imageMobile)}</Mobile>
            </div>
        );
    }
}

type BannerTeaserProps = {
    className?: string;
    textAlignment?: string;
};

export function renderBannerTeaser(
    banner: Banner,
    teaserProps: BannerTeaserProps = { textAlignment: "center", className: "mfcss_teaser-full-page" }
) {
    const firstImage = banner.images[0];
    return (
        <Teaser
            key={banner.placementId}
            isI18n={banner.isI18n ? banner.isI18n : false}
            textAlignment={banner.textAlignment || teaserProps.textAlignment || "center"}
            imageDesktop={firstImage.desktop.imageUrl}
            imageTablet={firstImage.tablet ? firstImage.tablet.imageUrl : null}
            imageMobile={firstImage.mobile ? firstImage.mobile.imageUrl : null}
            bannerText={banner.text}
            className={teaserProps.className || ""}
        />
    );
}
